import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { UserService } from 'src/app/services/user.service';
interface Clientes{
  id: number;
  name: string;
}
interface Establecimientos{
  establecimientoId: number;
  identificadorUnico: number;
  clienteId: number;
  label: string;
  name: string;
  numTanks: any;
  est_beertypes: any;
}
@Component({
  selector: 'app-agregar-pedido',
  templateUrl: './agregar-pedido.component.html',
  styleUrls: ['./agregar-pedido.component.css']
})
export class AgregarPedidoComponent {
  
  estado: number = 1;
  pedidoSolicitado: boolean = false;
  clientsData: any = [];
  tiempoEsperaRecarga: number = 60000;
  errorMessage: string = "";
  waitAfterSave: boolean = false;

  //ERROR
  errorFinalMessage: string = "";
  errorFinal: boolean = false;
  showEstablecimientoError: boolean = false;
  tankError: boolean = false;
  errorCamposIncorrectos: boolean = false;

  //ESTABLECIMIENTOS
  establecimientos: Establecimientos[] = [];
  establecimientosCopia: Establecimientos[] = [];
  selectAllEstablecimientos: boolean = false;
  //selectedEstablecimiento: number [] = [];
    //AUTOCOMPLETE
    myControl = new FormControl<string | Establecimientos>('');
    filteredOptions!: Observable<Establecimientos[]>;

  //TANQUES
  numTanks: any = [];
  selectAllTanks: boolean = false;
  selectedTank: any;

  //CERVEZAS
  cervezasData: any = [];
  cervezas: any;
  selectedCerveza: any;

  //LITROS
  configuracionPedido: FormGroup = new FormGroup({
    litrosCerveza: new FormControl('', [Validators.pattern(/^\d+(\.\d+)?(,\d+)?$/)]),
  });

  clientes: Clientes[] = [
  ];
  selectedCliente: number | undefined;

  hide = true;
  hideR = true;

  private clientsSubscription: Subscription | undefined;
  private cervezasSubscription: Subscription | undefined;
  private agregarUsuarioSubscription: Subscription | undefined;
  
  constructor(private deviceService : DeviceService, private router: Router, private error429: Error429Service){}

  get litrosCervezaInput() { 
    return this.configuracionPedido.get('litrosCerveza'); 
  }

  ngOnInit(): void {
    this.clientsSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
      next:resp =>{
        console.log(resp);
        for(let i=0; i<resp.length; i++){
          let numTanks: any = [];
          for(let j=0; j<resp[i].devices.length; j++){
            for(let x=0; x<resp[i].devices[j].tanks.length; x++){
              numTanks.push({
                id: resp[i].devices[j].tanks[x].id,
                custom_num: resp[i].devices[j].tanks[x].custom_num
              });
            }
          }
          this.establecimientos.push({
            establecimientoId: resp[i].id,
            identificadorUnico: resp[i].external_id,
            label: resp[i].est_name + ' (ID: '+resp[i].external_id+ ')',
            clienteId: resp[i].est_cliente_id,
            name: resp[i].est_name,
            numTanks: numTanks,
            est_beertypes: JSON.parse(resp[i].est_beertypes)
          });
          /*const isClientIdExists = this.clientsData.some((client:any) => client.id === resp[i].cliente.id);
          if(!isClientIdExists){
            this.clientsData.push(resp[i].cliente);
            this.clientes.push({
              id: resp[i].cliente.id,
              name: resp[i].cliente.razon_social
            });
          }*/
        }
        this.establecimientosCopia = this.establecimientos;
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => {
            const label = typeof value === 'string' ? value : value?.label;
            return label ? this._filter(label as string) : this.establecimientosCopia.slice();
          }),
        );
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        this.cervezasSubscription = this.deviceService.getBeerType().subscribe({
          next:resp =>{
            this.cervezasData = resp;
            console.log(this.cervezasData);
          },error:err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          }, complete:()=>{}
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
    if (this.agregarUsuarioSubscription) {
      this.agregarUsuarioSubscription.unsubscribe();
    } 
    if (this.cervezasSubscription) {
      this.cervezasSubscription.unsubscribe();
    } 
  }

  onTankSelectionChanged(event: Event) {
    console.log('Tanques seleccionados:', this.selectedTank);
  }

  /* Funcion que salta cada vez que se cambia el input de manera manual, de esta manera obligamos
  al usuario a seleccionar uno */
  onInputChanged(): void {
    const selectedDispositivo: string | Establecimientos | null = this.myControl.value;
    console.log(selectedDispositivo);
    if (selectedDispositivo && typeof selectedDispositivo !== 'string') {
      this.numTanks = selectedDispositivo.numTanks;
      this.cervezas = this.cervezasData.filter((cerveza:any) => selectedDispositivo.est_beertypes.includes(cerveza.id));
      console.log(this.cervezas);
    } else {
      this.numTanks = [];
      this.selectedTank = null;
      this.selectedCerveza = null;
    }
  }

  //AUTOCOMPLETE ESTABLECIMIENTOS
    private _filter(label: string): Establecimientos[] {
      const filterValue = label.toLowerCase();

      return this.establecimientosCopia.filter(option => option.label.toLowerCase().includes(filterValue));
    }

    displayFn(establecimiento: Establecimientos): string {
      return establecimiento && establecimiento.label ? establecimiento.label : '';
    }
  
    limpiarSeleccion(): void {
      this.myControl.setValue('');
      this.numTanks = [];
      this.cervezas = [];
      this.selectedTank = null;
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => {
          const label = typeof value === 'string' ? value : value?.label;
          return label ? this._filter(label as string) : this.establecimientosCopia.slice();
        }),
      );
    }

    onOptionSelected(event: MatAutocompleteSelectedEvent): void {
      const selectedDispositivo: string | Establecimientos | null = this.myControl.value;
      console.log(selectedDispositivo);
      if (selectedDispositivo && typeof selectedDispositivo !== 'string') {
        this.numTanks = selectedDispositivo.numTanks;
        this.cervezas = this.cervezasData.filter((cerveza:any) => selectedDispositivo.est_beertypes.includes(cerveza.id));
        console.log(this.cervezas);
      } else {
        this.numTanks = [];
        this.selectedTank = null;
        this.selectedCerveza = null;
      }
    }

    /*selectAllTanksChanged() {
      if (this.selectAllTanks) {
        this.selectedTank = this.numTanks;
      } else {
        this.selectedTank = [];
      }
    }*/

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  guardarUsuario(){
    const selectedEstablecimiento: string | Establecimientos | null = this.myControl.value;
    if(selectedEstablecimiento && typeof selectedEstablecimiento !== 'string'){
      this.showEstablecimientoError = false;
    } else {
      this.showEstablecimientoError = true;
    }
    
    if(!this.selectedTank){
      this.tankError = true;
    } else {
      this.tankError = false;
    }

    if(this.configuracionPedido.get('litrosCerveza')?.hasError('pattern')){
      this.errorCamposIncorrectos = true;
    } else {
      this.errorCamposIncorrectos = false;
    }

    if(!this.showEstablecimientoError && !this.errorCamposIncorrectos && !this.tankError && selectedEstablecimiento && typeof selectedEstablecimiento !== 'string'){

      let valorLitros = this.litrosCervezaInput?.value;
      if (typeof valorLitros === 'string') {
        valorLitros = valorLitros.replace(',', '.');
        valorLitros = parseFloat(valorLitros);
      }
      if(isNaN(Number(valorLitros))){
        valorLitros = undefined;
      }
      console.log('Litros:', valorLitros);
      console.log("El establecimiento seleccionado es: ", selectedEstablecimiento.establecimientoId.toString());
      console.log("Todos los tanques", this.numTanks);
      console.log('Tanque seleccionados:', this.selectedTank);
      console.log('Litros:', this.litrosCervezaInput?.value);
      console.log('Cerveza:', this.selectedCerveza);

      const pedido = new FormData();
      pedido.append('_method', "PUT");
      pedido.append('establishment_id', selectedEstablecimiento.establecimientoId.toString());
      pedido.append('tank_id', this.selectedTank);
      if(valorLitros !== undefined){
        pedido.append('litres_requested', valorLitros);
      }
      if(this.selectedCerveza !== undefined){
        pedido.append('beertype_id', this.selectedCerveza);
      }

      this.agregarUsuarioSubscription = this.deviceService.createPedido(pedido).subscribe({
        next:resp => {
          console.log(resp);
        }, error: err =>{
          this.errorFinalMessage = err.error.message;
          if(this.errorFinalMessage == undefined){
            this.errorFinalMessage = err.error.error;
          }
          console.log(err);
          if (!this.waitAfterSave) {
            this.pedidoSolicitado = false;
            this.waitAfterSave = true;
            this.errorFinal = true;
            setTimeout(() => {
              this.errorFinal = false;
              this.waitAfterSave = false;
            },3500)
          }
          //console.log(err.statusText);
        }, complete: () =>{
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.pedidoSolicitado =true;
            setTimeout(() => {
              this.pedidoSolicitado = false;
              this.waitAfterSave = false;
            }, 3500);
          }
        }
      });

    } else {
      this.pedidoSolicitado = false;
    }
    let valorLitros = this.litrosCervezaInput?.value;
    if (typeof valorLitros === 'string') {
      valorLitros = valorLitros.replace(',', '.');
      valorLitros = parseFloat(valorLitros);
    }
    if(isNaN(Number(valorLitros))){
      valorLitros = undefined;
    }
    console.log('Litros:', valorLitros);
    console.log("El establecimiento seleccionado es: ", selectedEstablecimiento || 'empty');
    console.log("Todos los tanques", this.numTanks);
    console.log('Tanque seleccionados:', this.selectedTank);
    console.log('Litros:', this.litrosCervezaInput?.value);
    console.log('Cerveza:', this.selectedCerveza);


    console.log('---------------------------------------');
  }

}
